<template>
  <section
    @click="addClass"
    :data-animate="animState"
    :style="formatStyle()"
    :class="animateTime ? animateTime + ' Card' : 'Card'"
  >
    <div class="PlusCircle">
      <div class="ThinYelowLine"></div>
      <div class="SymbolWrapper">
        <div class="Vline" />
        <div class="Hline" />
      </div>
    </div>
    <div class="YellowChip">
      <span class="HeaderText">{{ headerText }}</span>
      <div class="Layer" />
    </div>
    <div class="CardText"><slot></slot></div>
  </section>
</template>

<script>
import i18n from '../../../i18n';

export default {
  props: [
    'headerText',
    'col',
    'row',
    'align',
    'margin',
    'lineWidth',
    'justify',
    'left',
    'translateX',
  ],

  data() {
    return {
      animateTime: null,
      animState: 'inactive',
      germanPadding: { card: null, text: null },
    };
  },
  created() {
    // if user language is 'de' then reduce padding
    if (i18n.locale === 'de') {
      this.germanPadding.card = '20px';
      this.germanPadding.text = '.5em';
    }
  },
  methods: {
    addClass() {
      if (window.innerWidth >= 768) {
        return;
      }
      this.animateTime = this.animateTime ? null : 'animateBtn';
      this.animState = this.animState === 'active' ? 'inactve' : 'active';
    },
    formatStyle() {
      if (this.left) {
        return {
          '--col': this.col,
          '--row': this.row,
          '--align-self': this.align,
          '--margin': this.margin,
          '--yellow-line-width': this.lineWidth,
          '--justify': this.justify,
          '--circle-pos-right': '-20px',
          '--thin-yellow-line-left': '40px',
        };
      }
      return {
        '--circle-pos-left': '-20px',
        '--col': this.col,
        '--row': this.row,
        '--align-self': this.align,
        '--margin': this.margin,
        '--yellow-line-width': this.lineWidth,
        '--justify': this.justify,
        '--thin-yellow-line-right': '40px',
        '--translate-x': this.translateX,
        '--german-padding-card': this.germanPadding.card,
        '--german-padding-text': this.germanPadding.text,
      };
    },
  },
};
</script>

<style scoped>
/* Mobile Styling */
.Card {
  grid-row: var(--row);
  grid-column: var(--col);
  position: relative;
  background: white;
  box-shadow: 0px 5px 20px #00000029;
  border-radius: 12px;
  padding: 20px 1em 1em 1em;
  max-width: 175px;
  height: max-content;
  align-self: var(--align-self);
  font-size: 12px;
  color: var(--card-font-color);
  visibility: hidden;
  --card-font-color: #2b4047;
}
.HeaderText {
  visibility: visible;
}
.animateBtn {
  visibility: visible;
}

.Card[data-animate='active'] .PlusCircle {
  transform: rotate(45deg) scale(0.7);
  transition: transform 0.15s ease-in-out;
}
.Card[data-animate='active'] .Layer {
  transition: transform 0.3s ease-in-out;
  transform: none;
}
.Card[data-animate='active'] {
  z-index: 2;
}
/* .Card[data-animate='active'] .PlusCircle::after {
} */

.PlusCircle {
  --circle-bg: #fadf22;
  position: absolute;
  left: var(--circle-pos-left);
  right: var(--circle-pos-right);
  background: var(--circle-bg);
  top: calc(16px);
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  visibility: visible;
  transition: transform 0.25s ease-in-out;
}
.PlusCircle::after {
  z-index: 0;
  position: absolute;
  background: var(--circle-bg);
  opacity: 0.4;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  content: '';
  transition: opacity 0.25s linear;
}
.SymbolWrapper {
  width: 14px;
  height: 14px;
  display: grid;
  justify-items: center;
  align-items: center;
}

.Vline,
.Hline {
  grid-area: 1 / 1;
  border-radius: 5px;
  background: white;
  z-index: 2;
}
.Vline {
  height: 14px;
  width: 4px;
}
.Hline {
  height: 4px;
  width: 14px;
}

/* TODO(greg) remove duplicate css */
.YellowChip {
  position: relative;
  overflow: hidden;
  color: #2b4047;
  border-radius: 20px;
  width: max-content;
  padding: 0 0.6em;
  font-weight: bold;
  font-size: 12px;
  z-index: 1;
}
.Layer {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #ffdf22;
  z-index: -1;
  transform: translateX(-100%);
  transition: transform 0.25s ease-in-out;
}
/* Media Queries */

@media (min-width: 340px) {
  .Card {
    max-width: 230px;
  }
}

@media (min-width: 360px) {
  .Card {
    font-size: 14px;
  }
  .YellowChip {
    font-size: 14px;
  }
}

@media (min-width: 380px) {
  .Card {
    transform: translateX(var(--translate-x, 0));
  }
}

/* DESKTOP */
@media (min-width: 768px) {
  .Card {
    transform: none;
  }
  .PlusCircle {
    --circle-bg: #fadf22;
    position: absolute;
    left: var(--circle-pos-left);
    right: var(--circle-pos-right);
    background: var(--circle-bg);
    top: calc(30px - 7px + 2px);
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .PlusCircle::after {
    z-index: 0;
    position: absolute;
    background: var(--circle-bg);
    opacity: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    content: '';
    transition: opacity 0.25s linear;
  }
  .SymbolWrapper {
    width: 20px;
    height: 20px;
    display: grid;
    justify-items: center;
    align-items: center;
  }

  .Vline,
  .Hline {
    grid-area: 1 / 1;
    border-radius: 5px;
    background: white;
    z-index: 2;
  }
  .Vline {
    height: 20px;
    width: 4px;
  }
  .Hline {
    height: 4px;
    width: 20px;
  }
  .ThinYelowLine {
    position: absolute;
    height: 2px;
    width: var(--yellow-line-width, 80px);
    background: var(--circle-bg);
    top: 50%;
    right: var(--thin-yellow-line-right);
    left: var(--thin-yellow-line-left);
    z-index: -1;
  }
  .Card {
    grid-row: var(--row);
    grid-column: var(--col);
    position: relative;
    background: white;
    box-shadow: 0px 5px 20px #00000029;
    border-radius: 12px;
    max-width: 265px;
    padding: 12px;
    height: max-content;
    align-self: var(--align-self);
    justify-self: var(--justify, flex-start);
    margin-left: var(--margin, 0);
    font-size: 14px;
    visibility: visible;
  }
  .YellowChip {
    position: relative;
    overflow: hidden;
    color: #2b4047;
    border-radius: 20px;
    width: max-content;
    padding: 0 0.6em;
    margin-left: 0.2em;
    font-weight: bold;
    font-size: 14px;
    z-index: 1;
  }
  .Layer {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: #ffdf22;
    z-index: -1;
    transform: translateX(-100%);
    transition: transform 0.25s ease-in-out;
  }

  .CardText {
    padding: 0.3em 0.7em 0em 0.7em;
  }
  /* onHover Animation */

  .Card:hover .PlusCircle::after {
    transition: opacity 0.3s ease-in-out;
    opacity: 0.5;
  }
  .Card:hover .Layer {
    transition: transform 0.3s ease-in-out;
    transform: none;
  }
}

@media (min-width: 1024px) {
  .Card {
    padding: 16px;
    max-width: 300px;
    /* font-size: 16px; */
  }
  .CardText {
    padding: 0.7em;
  }
  .ThinYelowLine {
    width: var(--yellow-line-width, 156px);
  }
}
@media (min-width: 1200px) {
  .Card {
    max-width: 400px;
    font-size: 16px;
    padding: 18px;
  }
  .ThinYelowLine {
    width: var(--yellow-line-width, 156px);
  }
  .YellowChip {
    font-size: 16px;
  }
}
@media (min-width: 1400px) {
  .CardText {
    padding: var(--german-padding-text, 1.2em 1em 1em 1em);
  }
  .Card {
    padding: var(--german-paddin-card, 30px 1.5em 1.5em 1.5em);
    max-width: 510px;
    font-size: 20px;
  }
  .YellowChip {
    font-size: 20px;
  }
}
</style>
